import { render, staticRenderFns } from "./DatatableV1Properties.vue?vue&type=template&id=42ef7644&"
import script from "./DatatableV1Properties.vue?vue&type=script&lang=js&"
export * from "./DatatableV1Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Portal.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports